module.exports = __webpack_public_path__ + "static/media/square.6a389b27.svg";